<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pa-2 score-trans">
                <v-responsive>
                    <v-card-title class="caption-font">Bookings/timeslot
                        <v-spacer></v-spacer><span class="intro-font"><b>{{this.title}}</b></span>
                    </v-card-title>
                    <v-card-subtitle>What times do people book during the day, this year and the previous year</v-card-subtitle>
                    <v-container>
                        <div style="height: 250px; width: 100%;">
                        <canvas id="dailyv1-chart1" height="300" style="width:100%;"></canvas>
                        </div>
                    </v-container>
                </v-responsive>
            </v-card>
            <v-card-actions></v-card-actions>
        </v-container>
    </v-card>
</template>

<script>

    import mxbookingschart from '../mixins/daily_chart_V1';

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    
    //console.log(...registerables);

    import {bus} from "../../../../main";

    export default {
        data() {
            return {
                bookingsTY: [],
                bookingsPY: [], 
                title: '',
                chart: null,
            }
        },
        created(){ // set up event bus listener here on created event
            this.getBookingData('load');
            bus.$on("refresh", (data) => {
                console.log("refresh received for dailyv1 " + data);
                this.getBookingData('refresh');                
            });
        },                  
        mounted(){            

        },    
        mixins:[mxbookingschart],
        methods:{
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getBookingData(param){         
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getHourlyBookingsv1.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHourlyBookings"
                    },
                    })
                    .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log('v1');
                        this.bookingsTY = res.data.bookingsPerHourThisYear;    
                        this.bookingsPY = res.data.bookingsPerHourPreviousYear;    
                        if(param ==='load'){
                            const ctx = document.getElementById('dailyv1-chart1').getContext('2d');
                            this.chart = new Chart(ctx, this.createBarData(this.bookingsTY, this.bookingsPY, "bar")); // horizontalBar, bar                                
                        } else {
                            this.refreshChart(this.createBarData(this.bookingsTY, this.bookingsPY, "bar"));
                        }
                    }
                    })
                    .finally(() => {
                });
            },             
        }
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/not_a_sunset.png') !important;
        background-size: cover !important;
    }
    .intro-font {
        font-size: 12px;
    }
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .score-trans {
        background: transparent !important;
    }
</style>